<template>
  <div class="login-page">
    <app-navbar-login></app-navbar-login>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image" data-color="green">
        <div class="content">
          <div class="container">
              <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                <card type="login">
                  <h3 slot="header" class="text-center">Forgot Password?</h3>
                  <p>To reset your password, type the full email address associated with your account.</p>
                  <p v-bind:class="{ websphereShow: isHidden }">
                    {{ submitResult }}
                  </p>
                  <fg-input name="email"
                            type="email"
                            v-model="model.email"
                            v-validate="modelValidations.email"
                            :error="getError('email')"
                            addon-left-icon="nc-icon nc-single-02" placeholder="Email Address..."></fg-input>


                  <p-button slot="footer" type="success" round block class="mb-3" @click.prevent="validate">{{ loginButtonText }}</p-button>
                </card>
              </div>
          </div>
        </div>
        <app-footer-login></app-footer-login>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Card, Button} from 'src/components/UIComponents';
  import AppNavbarLogin from './Layout/AppNavbarLogin'
  import AppFooterLogin from './Layout/AppFooterLogin'
  export default {
    components: {
      Card,
      AppNavbarLogin,
      AppFooterLogin,
      [Button.name]: Button
    },
    data () {
      return {
      model: {
          email: '',
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          },
        },

        isHidden: true,
        loginButtonText: 'Submit',
        submitResult: ''
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
          if(isValid){
            this.forgotPassword()
          }
        })
      },

      forgotPassword () {
        this.loginButtonText = "Submitting ..."

        this.$http.post('/forgot-password', {
          email: this.model.email,
        })
        .then(response=>{
          
          if(response.data.message == "We have e-mailed your password reset link!") {
            this.submitResult = "We have e-mailed your password reset link."
          } else {
            this.submitResult = "Wrong or invalid email address."
          }
          this.isHidden = false

          this.model.email = ''
          this.loginButtonText = "Submit"

          this.$nextTick(function () {
            this.$validator.reset()
          })
        })
        .catch(error =>{
          this.loginButtonText = "Submit"
          this.submitResult = "Wrong or invalid email address."
        })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
.login-page .content .container { margin-top: 0px !important; margin-left: 0px;}
.ml-auto, .mx-auto { margin-left: 0px !important; }
.login-page #websphereCoded {margin-left: 40px !important;}
.login-page .h3, .login-page h3 {margin-bottom: 0px; line-height: normal }
.websphere-show  {display: none}
</style>
